import { makeAutoObservable } from "mobx"

class MessageStore {
	// confirmation dialog properties
	message: string = '';
	openConfirmation: boolean = false;
	onConfirm?: () => void = () => { };
	confirmationTitle: string = 'Confirm';
	showConfirmationCancel: boolean = true;

	// form dialog properties
	openForm: boolean = false;
	onSubmit: (comment: string) => Promise<void> = async () => { };
	inputLabel: string = 'Reason';
	maxLength: number = 255;

	constructor() {
		makeAutoObservable(this);
	}

	showConfirm(message: string, onConfirm: () => void) {
		this.message = message;
		this.openConfirmation = true;
		this.onConfirm = onConfirm;
		this.confirmationTitle = 'Confirm';
		this.showConfirmationCancel = true;
	}
	showInfo(message: string, title: string = 'Warning') {
		this.message = message;
		this.openConfirmation = true;
		this.onConfirm = undefined;
		this.confirmationTitle = title;
		this.showConfirmationCancel = false;
	}
	closeConfirm() {
		this.openConfirmation = false;
	}

	showForm(onSubmit: (input: string) => Promise<void>, inputLabel: string, maxLength: number) {
		this.openForm = true;
		this.onSubmit = onSubmit;
		this.inputLabel = inputLabel;
		this.maxLength = maxLength;
	}
	closeForm() {
		this.openForm = false;
	}
}

export const messageStore = new MessageStore()
